import { EEventType } from 'enums/lei/leiDetailDataEnums';

export const leiDetailZmenaSelect = [
    {
        labelcz: 'LEI_CHANGE_LEGAL_NAME',
        value: EEventType.CHANGE_LEGAL_NAME
    },
    {
        labelcz: 'LEI_CHANGE_OTHER_NAMES',
        value: EEventType.CHANGE_OTHER_NAMES
    },
    {
        labelcz: 'LEI_CHANGE_LEGAL_ADDRESS',
        value: EEventType.CHANGE_LEGAL_ADDRESS
    },
    {
        labelcz: 'LEI_CHANGE_HQ_ADDRESS',
        value: EEventType.CHANGE_HQ_ADDRESS
    },
    {
        labelcz: 'LEI_CHANGE_LEGAL_FORM',
        value: EEventType.CHANGE_LEGAL_FORM
    },
    {
        labelcz: 'LEI_DIC',
        value: EEventType.DIC
    },
    {
        labelcz: 'LEI_VZNIKSPOLECNOSTI',
        value: EEventType.VZNIKSPOLECNOSTI
    }
    /*  {
        labelcz: 'DISSOLUTION',
        value: EEventType.DISSOLUTION
    }, 
    {
        labelcz: 'LEI_OSTATNI',
        value: EEventType.OSTATNI
    }*/
];

export const leiZmenaStav = [
    {
        labelcz: 'IN_PROGRESS',
        value: 'IN_PROGRESS'
    },
    {
        labelcz: 'COMPLETED',
        value: 'COMPLETED'
    },
    {
        labelcz: 'WITHDRAWN_CANCELLED',
        labelen: 'WITHDRAWN_CANCELLED',
        value: 'WITHDRAWN_CANCELLED'
    }
];
